module.exports = __webpack_public_path__ + "static/flatart-slider-desktop-fce641584bb4d9433d2b8d20c5afb4a5.jpg";